import type { Element } from "@xmpp/xml"

export function parseNaviJson(result: Element): any {
  const command = result?.getChild("command")
  const json = command?.getChild("json", "urn:xmpp:json:0")
  if (!json) return null
  try {
    return JSON.parse(json.text())
  } catch {
    return null
  }
}
